// extracted by mini-css-extract-plugin
module.exports = {"modal-section-label__subtitle":"styles_modal-section-label__subtitle__2BC9P"};